import Omoss from "./Omoss";

export default Omoss;
